import { useContainer } from '../../useContainer';
import { ClientApi, ToastStateHandler } from '../../../api';
import { UpdateClientDto } from '../../../commonTypes/client.types';
import { dispatch } from '../../../store';
import { editClient, setShowEditClientForm } from '../../../store/slices/clients.slice';
import { useTranslation } from '../../useTranslation';

const useHttpPatchClient = () => {
    const { t } = useTranslation('newNotifications');
    const clientApi: ClientApi = useContainer(ClientApi);
    const toastHandler = useContainer(ToastStateHandler);

    const execSubmit = (clientId: string, body: UpdateClientDto, reason?: string) => {
        const { exec, abort } = clientApi.update({
            params: { clientId },
            body,
            onSuccess: _ => {
                dispatch(editClient({ clientId, updateClient: body }));
                dispatch(setShowEditClientForm(false));
                if (reason === 'basicInfo') {
                    toastHandler.push('success', t('clients.updateInfoTitle'), t('clients.updateInfoSuccess'));
                    return;
                }
                if (reason === 'customFields') {
                    toastHandler.push('success', t('clients.updateFieldTitle'), t('clients.updateFieldSuccess'));
                    return;
                }
                toastHandler.push('success', t('clients.updateTitle'), t('clients.updateSuccess'));
            },
            onError: _ => toastHandler.push('error', t('clients.updateTitle'), t('clients.updateError')),
        });
        exec();
        return abort;
    };

    return { execSubmit };
};

export default useHttpPatchClient;
